/* eslint-disable*/
// Lint 끄는 기능

import logo from './logo.svg';
import './App.css';
import { useState } from 'react';
import { flushSync } from 'react-dom';

function App() {

  let post ='강남 우동 맛집';
  let [글제목, 글제목변경] = useState(['남자 코트 추천','강남 우동맛집','파이썬독학']);
  let [따봉, 따봉변경] = useState([0,0,0]);
  let [modal, setModal] = useState(false);
  let [title, setTitle] =useState(0);
  let [입력값, 입력값변경] = useState('');
  

  // function 함수(){
  //   console.log(1);
  // }

  return (
    <div className="App">
      <div className="black-nav"> 
        <h4 style={{color : 'red', fontSize:'16px'}}>ReactBlog</h4>
      </div>

      <button onClick={()=>
        { 
          let copy = [...글제목];
          // 새로운 화살표 지정 ... 괄호 벗어남 [] 괄호생김
          copy.sort();
          글제목변경(copy);
        }
      }>정렬버튼 </button>

      {
        // a는 array 안에 있던 데이터
        // i는 반복문 돌때 마다 0부터 1씩 증각하는 정수
        // key을 사용해야 콘솔에 woraing 사라짐
        // 따봉은 array 자료여서 변경시 copy 활용
        // e.stopPropagation() 이벤트 버블링 방지
        글제목.map(function(a, i){
          return (
          <div className="list" key={i}>
            <h4 onClick={()=>{setModal(true); setTitle(i)}}>{글제목[i]}
            <span onClick={(e)=>{ e.stopPropagation();
              let copy = [...따봉];
              copy[i] = copy[i]+1;
              따봉변경(copy)
            }}>👍</span>{따봉[i]}</h4>
            <p>2월 17일 발행</p>
            <button onClick={()=>{
              let copy =[...글제목];
              copy.splice(i, 1);
              글제목변경(copy)
            }}>삭제</button>
          </div>
          )

        })
        
      }
        
      {
        modal == true ? <Modal title={title} 글제목변경={글제목변경} color={'yellow'} 글제목 ={글제목} /> : null
      }
      

     <input onChange={(e)=>{
      입력값변경(e.target.value);
      } }></input>

      <button onClick={()=>{
        let copy = [...글제목];
        copy.unshift(입력값);
        글제목변경(copy)

      }}>글발행</button>
      
      {/* <div className="list">
        <button onClick={()=>{setModal(true)}}>{글제목[0]} 
        {
          modal == true ? <Modal></Modal> : null
        }
        </button>
        <span onClick={()=>{{따봉변경(따봉+1)}}}>👍</span>
        {따봉}
        <p>2월 17일 발행</p>
      </div>

      <div className="list">
        <h4>{글제목[1]}</h4>
        <p>2월 17일 발행</p>
      </div>

      <div className="list">
        <h4>{글제목[2]}</h4>
        <p>2월 17일 발행</p>
      </div> */}

      
    </div>
  );

      function Modal(props){

        return(
        <div className='modal' style={{background : props.color}}>
          <h4>{props.글제목[props.title]}</h4>
          <p>날짜</p>
          <p>상세내용</p>
          <button onClick={()=>{props.글제목변경(['여자 코트 추천','강남 우동맛집','파이썬독학'])}}>글수정</button>
        </div>
        )
      }



}

export default App;
